var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/Rx';
import { HttpClientWrapper } from './httpClient';
import { KeycloakService } from './keycloak.service';
import { SharedService } from './shared.service';
var ExpedienteService = (function (_super) {
    __extends(ExpedienteService, _super);
    function ExpedienteService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        return _this;
    }
    ExpedienteService.prototype.findExpediente = function (id, usuario) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "expediente" + id + ".json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "?usuario=" + usuario;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findNoticiaExp = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "noticia" + id + ".json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/noticias";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findPartes = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "partes.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/partes";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findPersona = function (datos) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "parteExample.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/persona?data=" + btoa(SharedService.unescape(encodeURIComponent(datos)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findPersonasConexo = function (exp_id, ttr) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "parteExample.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/personasConexo?exp=" + exp_id + "&ttr=" + ttr;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findProfesional = function (datos) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "partes.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/profesional?data=" + btoa(SharedService.unescape(encodeURIComponent(datos)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findTasas = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tasas.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/tasas";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findAudiencias = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "agenda.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/audiencias";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findEscritos = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "escritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escritos?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findEscritosByUsr = function (id, page, size, usu) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "escritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escritosByUsr?page=" + page + "&size=" + size + "&usu=" + usu;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findAdjuntosEscritos = function (id, idEscrito) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "adjuntosescritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escrito/" + idEscrito + "/adjuntos";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.toString(); });
    };
    ExpedienteService.prototype.findEscrito = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "escrito.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escrito/" + id + "?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findPases = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "pases.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/pases?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findSaldos = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "saldos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/saldos?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findRegistroPaseEstudio = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "registro-pase-estudio.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/regPaseEstudio?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.getPdfComprobanteEscrito = function (id, idEscrito) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "adjuntosescritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escrito/" + idEscrito + "/comprobante";
        }
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        });
        var options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this._http.get(wsUrl, options)
            .map(function (response) {
            var fileBlob = response._body;
            var blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });
            return blob;
        });
    };
    ExpedienteService.prototype.getPdfEscrito = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "escrito.raw";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/escrito/" + id + "/pdf";
        }
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        });
        var options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this._http.get(wsUrl, options)
            .map(function (response) {
            var fileBlob = response._body;
            var blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });
            return blob;
        });
    };
    ExpedienteService.prototype.findActuaciones = function (id, page, size, orderByColumn, orderByDirection) {
        var wsUrl;
        if (this.isLocalData()) {
            //wsUrl = this.url() + "actuaciones" + id + "-" + page + ".json";
            wsUrl = this.url() + "actuaciones3766-0.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/actuaciones?page=" + page + "&size=" + size + "&orderByColumn=" + orderByColumn + "&orderByDirection=" + orderByDirection;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.addFavorito = function (id, usu) {
        var wsUrl;
        //console.log("Usuario " + KeycloakService.getLoggedUser());
        wsUrl = this.urlSer() + "expediente/addFavorito/" + id + "/" + KeycloakService.getLoggedUser();
        //console.log("add favorito servicio: " + wsUrl);
        return this._http.post(wsUrl, "")
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.delFavorito = function (id, usu) {
        var wsUrl;
        //console.log("Usuario " + KeycloakService.getLoggedUser());
        wsUrl = this.urlSer() + "expediente/delFavorito/" + id + "/" + KeycloakService.getLoggedUser();
        //console.log("del favorito servicio: " + wsUrl);
        return this._http.post(wsUrl, "")
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findAvanzada = function (filter) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "novedades.json";
        }
        else {
            //let codigos = "5429,5430,5432,5433,5434,5444";
            var codigos = "";
            if (KeycloakService.usr.repCodigos != null) {
                codigos = KeycloakService.usr.repCodigos.join(",");
            }
            //console.log("RepCodigos: " + codigos);
            wsUrl = this.urlSer() + "expediente/findAvanzada/?data=" + filter + "&cod=" + btoa(SharedService.unescape(encodeURIComponent(codigos)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.uploadEscrito = function (name, file) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "upload.json";
        }
        else {
            wsUrl = this.url() + "expediente/escrito";
        }
        return this.upload(wsUrl, name, file);
    };
    ExpedienteService.prototype.uploadAdjunto = function (eid, name, file) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "upload.json";
        }
        else {
            wsUrl = this.url() + "expediente/adjunto/" + eid;
        }
        //name = name.replace(/([^a-zA-Z0-9 ñÑÁÉÍÓÚÜüñáéíóú.]+)/gi, '');
        return this.upload(wsUrl, name, file);
    };
    ExpedienteService.prototype.upload = function (url, name, file) {
        if (this.isLocalData()) {
            return this._http.get(url).map(function (response) { return response.json(); });
        }
        else {
            return this._http.post(url, btoa(SharedService.unescape(encodeURIComponent(name))) + ";" + file)
                .map(function (response) { return response.json(); });
        }
    };
    ExpedienteService.prototype.getFile = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "uploaded.json";
        }
        else {
            wsUrl = this.url() + "expediente/file/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.getFilePreview = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "uploaded.json";
        }
        else {
            wsUrl = this.url() + "expediente/filepreview/" + id + "?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.cleanupServer = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = "{\"result\": true}";
        }
        else {
            wsUrl = this.url() + "expediente/cleanup/" + id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.saveSignatures = function (id, escrito) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "save-escrito.json";
            return this._http.get(wsUrl)
                .map(function (response) { return response.json(); });
        }
        else {
            wsUrl = this.urlSer() + "expediente/save/" + id;
            return this._http.post(wsUrl, escrito)
                .map(function (response) { return response.json(); });
        }
    };
    ExpedienteService.prototype.downloadExp = function (id, usu) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargar/" + id + "?usu=" + usu;
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/pdf' });
        });
    };
    ExpedienteService.prototype.adjuntosEscrito = function (expId, escid) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/" + expId + "/escrito/" + escid + "/adjuntos";
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    ExpedienteService.prototype.adjuntosAct = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "actuaciones/adjuntosiurix/" + id;
        //console.log("get adjuntos " + wsUrl);
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    ExpedienteService.prototype.insertExp = function (data, id) {
        var wsUrl;
        //console.log("ingreso causa " + data);
        if (this.isLocalData()) {
            wsUrl = this.url() + "nuevoExpediente.json";
        }
        else {
            data =
                wsUrl = this.urlSer() + "ingresocausa/insert?data=" + SharedService.b64EncodeUnicode(data) + "&id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.insertMasivo = function (data, id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "nuevoExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/insertMasivo?data=" + SharedService.b64EncodeUnicode(data) + "&id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.uploadDocumento = function (name, file) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "upload.json";
        }
        else {
            wsUrl = this.url() + "home/documentoUpload";
        }
        return this.upload(wsUrl, name, file);
    };
    ExpedienteService.prototype.imprimirReporte = function (exp_id, masivo, usu) {
        var wsUrl;
        if (masivo)
            wsUrl = this.urlSer() + "ingresocausa/imprimirReporte/?data=" + btoa(SharedService.unescape(encodeURIComponent(exp_id))) + "&masivo=" + true + "&usu=" + usu;
        else
            wsUrl = this.urlSer() + "ingresocausa/imprimirReporte/?data=" + exp_id + "&masivo=" + masivo + "&usu=" + usu;
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (res) {
            //console.log("REPORTE");
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    ExpedienteService.prototype.loadExcel = function (id, inst, org_id, tipo, cir, usaRenaper) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "causamasivo.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/loadMasivos?id=" + btoa(SharedService.unescape(encodeURIComponent(id))) + "&inst=" + inst + "&org_id=" + org_id + "&tipo=" + tipo + "&cir=" + cir + "&usaRenaper=" + usaRenaper;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findTiposExpediente = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tiposExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/tiposExpediente";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findTiposExpedienteByFue = function (fue) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tiposExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/tiposExpedienteByFue?fue=" + fue;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findTiposExpedienteIurix = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tiposExpediente.json";
        }
        else {
            wsUrl = "app/data/tiposExpedienteIurix.json";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findAllTiposExpediente = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tiposExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/allTiposExpediente";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findTipoExp = function (tex_cod) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "tipoExp.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/tipoExpediente/" + tex_cod;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findInstancias = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "instancia.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/instancias";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.sleep = function (milliseconds) {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
            if ((new Date().getTime() - start) > milliseconds) {
                break;
            }
        }
    };
    ExpedienteService.prototype.findNovedades = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "novedades.json";
        }
        else {
            //let codigos = "5429,5430,5432,5433,5434,5444";
            var codigos = "";
            if (typeof (KeycloakService.usr) != "undefined" && KeycloakService.usr.repCodigos != null) {
                codigos = KeycloakService.usr.repCodigos.join(",");
            }
            //console.log("RepCodigos: " + codigos);
            wsUrl = this.urlSer() + "expediente/novedades/" + KeycloakService.getLoggedUser() + "?cod=" + btoa(SharedService.unescape(encodeURIComponent(codigos))) + "&page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findNovedadesByAcc = function (id, page, size, accion) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "novedades.json";
        }
        else {
            //let codigos = "5429,5430,5432,5433,5434,5444";
            var codigos = "";
            if (typeof (KeycloakService.usr) != "undefined" && KeycloakService.usr.repCodigos != null) {
                codigos = KeycloakService.usr.repCodigos.join(",");
            }
            //console.log("RepCodigos: " + codigos);
            //wsUrl = this.urlSer() + "expediente/novedadesbyacc/" + KeycloakService.getLoggedUser() + "?cod=" + btoa(codigos) + "&page=" + page + "&size=" + size + "&accion=" + accion ;
            wsUrl = this.urlSer() + "expediente/novedadesbyacc/?id=" + KeycloakService.getLoggedUser() + "&cod=" + btoa(SharedService.unescape(encodeURIComponent(codigos))) + "&page=" + page + "&size=" + size + "&accion=" + accion;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findFavoritos = function (id, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "favoritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/favoritos/" + KeycloakService.getLoggedUser() + "?page=" + page + "&size=" + size;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findFavoritosByAcc = function (id, page, size, accion) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 10; }
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "favoritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/favoritosbyacc/?id=" + KeycloakService.getLoggedUser() + "&page=" + page + "&size=" + size + "&accion=" + accion;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    /*
        public findDobleIniciacion(id_per: string, id_dem: string): Observable<Expediente> {
            var wsUrl: string;
    
            if (this.isLocalData()) {
                wsUrl = this.url() + "expediente3766.json";
            } else {
                wsUrl = this.urlSer() + "ingresocausa/dobleiniciacion/" + id_per + "/" + id_dem;
            }
            return this._http.get(wsUrl)
                .map(response => <Expediente>response.json());
        }
    */
    ExpedienteService.prototype.findDobleIniciacion = function (data, ttr_id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "expediente3766.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/dobleiniciacion?data=" + SharedService.b64EncodeUnicode(data) + "&ttrId=" + ttr_id;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.findExpConexo = function (tipo, nro, anio) {
        var wsUrl;
        if (this.isLocalData()) {
            if (anio == '18') {
                wsUrl = this.url() + "expediente00.json";
            }
            else {
                wsUrl = this.url() + "expediente3766.json";
            }
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/findExpConexo?tipo=" + tipo + "&nro=" + nro + "&anio=" + anio;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.tieneAcumulado = function (exp) {
        var wsUrl;
        wsUrl = this.url() + "expediente/tieneAcumulado?exp=" + exp;
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.downloadExpPDF = function (data) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargarPDF?data=" + SharedService.b64EncodeUnicode(data);
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/pdf' });
        });
    };
    ExpedienteService.prototype.downloadExpZIP = function (data) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargarZIP?data=" + SharedService.b64EncodeUnicode(data);
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    ExpedienteService.prototype.findAcciones = function () {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/acciones";
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.insertMasivoThread = function (data, id, sessionId) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "nuevoExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/insertMasivoThread?data=" + SharedService.b64EncodeUnicode(data) + "&id=" + btoa(SharedService.unescape(encodeURIComponent(id))) + "&sessionId=" + sessionId;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.getResultadoInsertMasivoThread = function (id) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "nuevoExpediente.json";
        }
        else {
            wsUrl = this.urlSer() + "ingresocausa/getResultadoInsertMasivoThread?id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.downloadExpThread = function (id, usu, sessionId) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargarExpThread/" + id + "?usu=" + usu + "&sessionId=" + sessionId;
        return this._http.get(wsUrl)
            .map(function (response) { return response.text(); });
    };
    ExpedienteService.prototype.getResultadodownloadExpThread = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/getResultadoDescargaExpThread?id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/pdf' });
        });
    };
    ExpedienteService.prototype.downloadExpPDFThread = function (data, sessionId) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargarExpPDFThread?data=" + SharedService.b64EncodeUnicode(data) + "&sessionId=" + sessionId;
        return this._http.get(wsUrl)
            .map(function (response) { return response.text(); });
    };
    ExpedienteService.prototype.getResultadodownloadExpPDFThread = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/getResultadoDescargaExpPDFThread?id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/pdf' });
        });
    };
    ExpedienteService.prototype.downloadExpZIPThread = function (data, sessionId) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/descargarExpZIPThread?data=" + SharedService.b64EncodeUnicode(data) + "&sessionId=" + sessionId;
        return this._http.get(wsUrl)
            .map(function (response) { return response.text(); });
    };
    ExpedienteService.prototype.getResultadodownloadExpZIPThread = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/getResultadoDescargaExpZIPThread?id=" + btoa(SharedService.unescape(encodeURIComponent(id)));
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (response) {
            var blob = response.blob();
            return new Blob([blob], { type: 'application/zip' });
        });
    };
    ExpedienteService.prototype.findRepresentanteQr = function (id, perId, proId, vinId, page, size) {
        if (page === void 0) { page = 0; }
        if (size === void 0) { size = 5; }
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/" + id + "/getRepresentanteQr?perId=" + perId + "&proId=" + proId + "&tviId=" + vinId + "&page=" + page + "&size=" + size;
        ;
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.getPdfComprobanteRepresentante = function (id, uuidParId) {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = this.url() + "adjuntosescritos.json";
        }
        else {
            wsUrl = this.urlSer() + "expediente/" + id + "/getRepresentanteQr/" + uuidParId + "/comprobante";
        }
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        });
        var options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this._http.get(wsUrl, options)
            .map(function (response) {
            var fileBlob = response._body;
            var blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });
            return blob;
        });
    };
    ExpedienteService.prototype.pagarTasa = function (id) {
        var wsUrl;
        //console.log("Usuario " + KeycloakService.getLoggedUser());
        wsUrl = this.urlSer() + "tasas/pagarTasa/" + id;
        //console.log("del favorito servicio: " + wsUrl);
        return this._http.post(wsUrl, "")
            .map(function (response) { return response.json(); });
    };
    ExpedienteService.prototype.getTasa = function (id) {
        var wsUrl;
        wsUrl = this.url() + "tasas/getTasa/" + id;
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    return ExpedienteService;
}(SharedService));
ExpedienteService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], ExpedienteService);
export { ExpedienteService };
//# sourceMappingURL=expediente.service.js.map